import { render, staticRenderFns } from "./claimApplication.vue?vue&type=template&id=2b80f888&scoped=true&"
import script from "./claimApplication.vue?vue&type=script&lang=js&"
export * from "./claimApplication.vue?vue&type=script&lang=js&"
import style0 from "./claimApplication.vue?vue&type=style&index=0&id=2b80f888&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.10.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b80f888",
  null
  
)

export default component.exports